import React, { Dispatch, useEffect } from 'react';
import { Stack } from '@mui/material';
import { fullSize } from '../../../Constants';
import Footer from '../../General/Footer/Footer';
import Header from '../../General/Header/Header';
import { useParams } from 'react-router-dom';
import { fetchDocumentDetails } from '../../../util/ProjectUtils';
import DocumentDetailsViewContainer from './DocumentDetailsViewContainer';
import { IAppReduxStore } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectLogOpen } from '../../../redux/general/sliceDatabaseAccess';
import { useFilesOpen } from '../../../hooks/useFilesOpen';
import { useAddFiles } from '../../../hooks/useAddFiles';
import DialogsWrapper from '../../General/Dialogs/DialogsWrapper/DialogsWrapper';

/**
 * Application view that displays the document's details.
 */
export default () => {
    /** Allow component to change the URL. */
    const { replicaId, universalId } = useParams();
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Open Files hook with error handling */
    useFilesOpen();

    /** Add Files hook with error handling */
    useAddFiles();

    const { canAccessDatabase } = useSelector((store: IAppReduxStore) => store.databaseAccess);

    useEffect(() => {
        dispatch(getProjectLogOpen({ replicaId }));
    }, [replicaId, universalId]);

    useEffect(() => {
        if (canAccessDatabase) {
            fetchDocumentDetails({ replicaId, universalId });
        }
    }, [replicaId, universalId, canAccessDatabase]);

    return (
        <DialogsWrapper>
            <Stack direction='column' sx={{ ...fullSize, flexGrow: 4 }}>
                <Header />
                <DocumentDetailsViewContainer />
                <Footer />
            </Stack>
        </DialogsWrapper>
    );
};
